import { FC, useEffect, useState } from "react";
import msi_logo from "../../assets/msi_logo.png";
import "./user-access-layout.css";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/hooks/useAuth";
import { Spinner } from "@heroui/react";
import { TLoggedInUserInfo } from "../../shared/types/loggedInUserInfo";
import axiosInstance from "../../shared/api/axiosInstance";

interface IUserAccessLayoutProps {
  children?: React.ReactNode;
}

const UserAccessLayout: FC<IUserAccessLayoutProps> = () => {
  const [loggedInUserInfo, setLoggedInUserInfo] = useState<TLoggedInUserInfo | null>(null);
    const navigate = useNavigate();
    const { isAuthenticated, isLoading } = useAuth();

     useEffect(() => {

        if (isAuthenticated && loggedInUserInfo === null) {
            axiosInstance.get('/token/userinfo', { withCredentials: true })
                .then((response) => {
                    if (!response.data) {
                        navigate('/account/login', { replace: true });
                    }
                    else {
                        setLoggedInUserInfo(response.data);
                    }

                })
                .catch((error) => {
                    navigate('/error', { replace: true });
                    console.error("Error fetching user info:", error);
                });
        }

    }, [isAuthenticated, loggedInUserInfo, navigate]);

  return (
    <div className="user-access-layout-container grid grid-cols-6 items-center md:space-x-4 ">
      <div className="brand col-span-6 md:col-span-3 lg:col-span-2">
        <img src={msi_logo} alt="MSI" />
      </div>
      {isLoading ? (
        <div className="form col-span-6 md:col-span-3 lg:col-span-4 flex justify-center items-center">
          <Spinner
            size="lg"
            label="Loading..."
            classNames={{ label: "text-md" }}
            variant="simple"
          />
        </div>
      ) : isAuthenticated &&
        !window.location.pathname.includes("/account/change-password")&&
        !window.location.pathname.includes("/account/forgot-password") ? (
        <Navigate to="/product-selection" />
      ) : (
        <Outlet context={loggedInUserInfo} />
      )}
    </div>
  );
};

export default UserAccessLayout;
